import getPathReduxUtil from 'modules/redux/utils/get-path'
import isNewReduxUtil from 'modules/redux/utils/is-new'
import setUtil from 'utils/set'
import createPointerCreateReduxUtil from 'modules/redux/actions/create/create-pointer'
import { getObjectUtil } from 'packages/src'

export default function createAssociationListCreateReduxUtil (payload) {
  const {
    stateWrapper,
    association,
    existingInstance,
    isLocal,
    instance,
    dataPath,
    properties,
    associationKey
  } = payload
  const pointers = association.map((assoc, index) => {
    let existingAssociation
    if (existingInstance && isNewReduxUtil(existingInstance)) {
      const existingAssociations = getObjectUtil(stateWrapper.state, `${getPathReduxUtil(existingInstance)}.changed.${associationKey}`) || []
      existingAssociation = existingAssociations[index]
    }
    return createPointerCreateReduxUtil(stateWrapper, {
      referencePath: `${getPathReduxUtil(instance)}.${dataPath}`,
      association: assoc,
      properties,
      isLocal,
      existingInstance: existingAssociation
        ? getObjectUtil(stateWrapper.state, getPathReduxUtil(existingAssociation))
        : null
    })
  })
  return setUtil(instance, dataPath, pointers)
}
